import {
    calendarGamePath,
    timeFilterSlug,
} from '@app/router/constants/linkConstants';
import { RouteIdentity } from '@app/router/types';
import {
    getConfig,
    IntroPageType,
} from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';

export const LinkEn: RouteIdentity<string> = {
    App: {
        Home: `/${timeFilterSlug}?`,
        Info: '/info',
        Wiki: '/wiki/:pageSlug',
        NotFound: '/404',
        NotAuthorized: '/401',
        TermsAndConditions: '/terms-and-conditions',
        CatchAll: '*',
        IdCardVerificationCaptive: '/verify-identity',
        VerifyPhoneCaptive: '/verify-phone',
    },
    Account: {
        Container: '/profile',
        Profile: '', // empty on purpose
        PaymentGatewayStatus: 'static/html/paymentGatewayStatus.html',
        Activate: '/activate-account',
        PasswordRecovery: '/password-recovery',
        ForgotPassword: '/forgot-password',
        Recovery: '/account-recovery',
        Register: '/register',
        ResendActivationEmail: '/resendActivationEmail',
        ContinueRegistration: '/continue-registration',
        Deposit: 'deposit',
        History: 'history/:type?',
        Settings: 'settings',
        Withdrawal: 'withdrawal',
        DocumentUpload: 'document-upload',
        IdentityVerification: 'identity-verification',
        IdentityVerificationUploadAdditional: 'documents-upload',
        ResponsibleGaming: 'responsible-gaming',
        DepositLimit: 'responsible-gaming/deposit-limit',
        BettingLimit: 'responsible-gaming/betting-limit',
        LossLimit: 'responsible-gaming/loss-limit',
        SessionLimit: 'responsible-gaming/session-limit',
        SelfExclusion: 'responsible-gaming/self-exclusion',
        TimeOut: 'responsible-gaming/time-out',
        RealityCheck: 'responsible-gaming/reality-check',
        AccountClosure: 'responsible-gaming/account-closure',
        MyMessages: 'my-messages',
        ChangePhone: 'change-phone',
        ReferAFriend: 'refer-a-friend',
        HelpAndSupport: 'help-and-support',
        ChatPlaceholder: 'chat',
        MySocial: 'my-social',
        EditMySocial: 'edit-social-profile',
        BlockedUsers: 'blocked-users',
        MyAccount: 'my-account',
        ChangePassword: 'password-update',
        SettingsBetslip: 'betslip',
        SwitchLanguage: 'switch-language',
        SwitchTheme: 'switch-theme',
        LicencePreferences: 'licence-preferences',
        LoginHistory: 'login-history',
        AccountSecurity: 'account-security',
    },
    Sport: {
        OfferEvent: '/offer-event/:eventSlug/',
        PrematchOffer: '/sport-bets',
        BetSlip: '/betslip',
        Filter: '/filter',
        Search: '/search',
        Favourites: '/favourites',
        Category: '/sport-bets/:sportSlug?/:categorySlug?',
        CategoryPerTime: `/sport-bets/:sportSlug?/:categorySlug?/${timeFilterSlug}`,
        SportCompetitions: '/sport-bets/:sportSlug/competitions',
        Competition: `/sport-bets/:sportSlug/:categorySlug/:tournamentSlug/${timeFilterSlug}?`,
        EventRedirect: '/event/:id(\\d+)',
        TournamentRedirect: '/tournament/:id([\\d,]+)',
        CategoryRedirect: '/category/:id(\\d+)',
        SuperAdvantage: '/super-advantage/:sportSlug?',
        PriceBoost: '/price-boost/:sportSlug?',
        MultiEventBetBuilder: '/multi-bet-builder/:sportSlug?',
        PopularBets: '/popular-bets',
        TopWinners: '/top-winners',
        Social: '/sport-bets/:sportSlug/social',
    },
    Lottery: {
        Offer: `/lotto-bets/${timeFilterSlug}?`,
    },
    News: {
        Feed: '/news',
        Article: '/news/:articleSlug',
        Articles: '/articles',
    },
    Free2Play: {
        BingoBash: '/bingobash',
        SuperSpin: '/superspin',
        FreeGamesInfo: '/free-games',
        SportCaller: '/superprono',
        SuperMillion: '/supermillion',
        CalendarGame: `/${calendarGamePath}`,
        SuperShot: '/supershot',
        TopManager: '/top-manager',
        FantasticDuels: '/fantasticDuels.path',
    },
    GrowthMarketing: {
        // because in Napoleon this page is home
        LandingIntro:
            getConfig().introPageSetup?.type === IntroPageType.ShowEveryTime ? '/home' : '/intro',
        PromotionsInfo: '/promotions',
        NewBettingSiteSerbia: '/nova-kladionica-u-srbiji',
    },
    Native: {
        AppsFooter: '/footerframe',
        Wiki: '/nativewiki/:pageSlug',
    },
    BonusAndComms: {
        LpBonus: '/primulbonus*',
        // Napoleon cannot use bonus wording
        PromotionHub:
            getConfig().countrySpecific.country === Country.Be
                ? '/promotions-and-rewards'
                : '/promotions-and-bonuses',
        Notifications: '/notifications',
        MarketingConsent: 'marketing-consent',
    },
    Loyalty: {
        Supercoins: '/supercoins',
    },
};
